import { render, staticRenderFns } from "./SeasonStats.vue?vue&type=template&id=5d3dd227&"
import script from "./SeasonStats.vue?vue&type=script&lang=js&"
export * from "./SeasonStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports